
export const getForCategory = () => {
  if (window.forCategory) {
    return decodeURI(window.forCategory)
  }
  return ''
}

export const getCategoryPath = () => {
  return window.categoryPath
}

export const getSearchQuery = () => {
  if (window.searchQuery) {
    return decodeURI(window.searchQuery)
  }
  return ''
}

export const getCurrentSelectedFilters = () => {
  const productLinkType = getProductLinkType()
  const filters = window.selectedFilters
    ? JSON.parse(window.selectedFilters.replace(/&quot;/g, '"'))
    : { string_filters: [], number_filters: [], number_range_filters: [] }

  const forSaleStringFilter = { name: 'For Sale', values: ['Yes'] }
  const forRentStringFilter = { name: 'For Rent', values: ['Yes'] }

  const alreadyHasForSaleFilter = !!filters.string_filters.filter(f => {
    return JSON.stringify(f) === JSON.stringify(forSaleStringFilter)
  }).length

  const isForSalePage = window.location.search.includes('for_sale=yes') || alreadyHasForSaleFilter

  const alreadyHasForRentFilter = !!filters.string_filters.filter(f => {
    return JSON.stringify(f) === JSON.stringify(forRentStringFilter)
  }).length

  if ((productLinkType === 'buy' || isForSalePage) && !alreadyHasForSaleFilter) {
    filters.string_filters.push(forSaleStringFilter)
  }

  if (productLinkType === 'rent' && !alreadyHasForRentFilter && !isForSalePage) {
    filters.string_filters.push(forRentStringFilter)
  }

  return JSON.stringify(filters)
}

export const getLocationPathname = () => {
  return location.pathname
}

export const getProductLinkType = () => {
  return window.sessionStorage.getItem('productLinkType') || 'rent'
}

export const passDataToBackbone = (result, showBuyLinks) => {
  window.Search.Data = result
  // eslint-disable-next-line no-undef
  window.searchView = new Search.Views.SearchView({
    searchQuery: window.searchQuery,
    showBuyLinks: showBuyLinks
  })
}

export default { getForCategory, getCategoryPath, getSearchQuery, getCurrentSelectedFilters, getLocationPathname, getProductLinkType, passDataToBackbone }
